import { LegendModel } from 'src/app/shared/models/legend.model'

export const obstacleLegendVehicleData: LegendModel = {
  type: 'hazard',
  category: 'vehicle',
  items: [
    {
      description: 'Accidents',
      value: 'accidents-hazard',
    },
    {
      description: 'BDV',
      value: 'bdv-hazard',
    },
  ],
}

export const obstacleLegendProvider1Data: LegendModel = {
  type: 'hazard',
  category: 'provider1',
  items: [
    {
      description: 'Accidents',
      value: 'accidents-hazard',
    },
    {
      description: 'BDV',
      value: 'bdv-hazard',
    },
    {
      description: 'CS',
      value: 'cs-hazard',
    },
  ],
}
export const obstacleLegendProvider2Data: LegendModel = {
  type: 'hazard',
  category: 'provider2',
  items: [
    {
      description: 'Accidents',
      value: 'accidents-hazard',
    },
    {
      description: 'BDV',
      value: 'bdv-hazard',
    },
    {
      description: 'CS',
      value: 'cs-hazard',
    },
  ],
}

export const obstacleLegendProvider3Data: LegendModel = {
  type: 'hazard',
  category: 'provider3',
  items: [
    {
      description: 'Accidents',
      value: 'accidents-hazard',
    },
    {
      description: 'BDV',
      value: 'bdv-hazard',
    },
    {
      description: 'CS',
      value: 'cs-hazard',
    },
  ],
}

export const obstacleLegendProvider4Data: LegendModel = {
  type: 'hazard',
  category: 'provider4',
  items: [
    {
      description: 'Accidents',
      value: 'accidents-hazard',
    },
    {
      description: 'BDV',
      value: 'bdv-hazard',
    },
  ],
}

export const obstacleLegendProvider6Data: LegendModel = {
  type: 'hazard',
  category: 'provider6',
  items: [
    {
      description: 'Accidents',
      value: 'accidents-hazard',
    },
    {
      description: 'BDV',
      value: 'bdv-hazard',
    },
  ],
}

export const obstacleLegendProvider7Data: LegendModel = {
  type: 'hazard',
  category: 'provider7',
  items: [
    {
      description: 'Accidents',
      value: 'accidents-hazard',
    },
    {
      description: 'BDV',
      value: 'bdv-hazard',
    },
  ],
}

export const obstacleLegendProvider8Data: LegendModel = {
  type: 'hazard',
  category: 'provider8',
  items: [
    {
      description: 'Accidents',
      value: 'accidents-hazard',
    },
    {
      description: 'BDV',
      value: 'bdv-hazard',
    },
  ],
}

export const obstacleLegendProvider9Data: LegendModel = {
  type: 'hazard',
  category: 'provider9',
  items: [
    {
      description: 'CS',
      value: 'cs-hazard',
    },
    {
      description: 'SV',
      value: 'sv-hazard',
    },
  ],
}

export const roadHazardLegendObstacles: LegendModel = {
  type: 'prediction',
  category: 'calculated',
  items: [
    {
      description: 'warning',
      value: 'dangerous',
    },
  ],
}
